export const BASE_URL = "https://hollas-price-management-backend.onrender.com"